export default __webpack_public_path__ + "asset/img/icon-host~c5b510e0.png";